import PageHero from '@/components/feature/PageHero';

export default function YunNodeHero() {
  return (
    <PageHero
      eyebrow="九畴云铺 · 数字商业节点"
      title="每一个人，都可以成为县域数字商业节点"
      titleHighlight="云社员 · 云店"
      desc="这是九畴云铺与传统电商最重要的差异——不再是单纯的「买货」，而是「买货 + 卖货 + 服务」的完整节点能力。"
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20network%20of%20connected%20individual%20nodes%20forming%20a%20digital%20commerce%20constellation%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20people%20and%20store%20nodes%20linked%20by%20light%20streams%2C%20rural%20digital%20economy%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1800&height=1100&seq=jiuchou-node-01&orientation=landscape"
      imageAlt="九畴云铺 数字商业节点 云社员云店"
      imageTitle="九畴云铺 数字商业节点"
    />
  );
}